const findIndexOf = (array: number[], value: number) => {
    let j = 0;
    let { length } = array;
    let i = 0;
    while (j < length) {
        // floor of ((length - 1) + j) / 2
        // eslint-disable-next-line no-bitwise
        i = (length + j - 1) >> 1;
        if (value > array[i]) {
            j = i + 1;
        } else if (value < array[i]) {
            length = i;
        } else {
            return i;
        }
    }
    return -1;
};

// Returns an array of items, that ARE part of arr1
// and NOT PART of arr2
// TODO: optimize
export const diffArray = (arr1: number[], arr2: number[]): number[] => {
    const { length } = arr1;
    const diffArr: number[] = [];
    for (let i = 0; i < length; i += 1) {
        if (findIndexOf(arr2, arr1[i]) === -1) {
            diffArr.push(arr1[i]);
        }
    }
    return diffArr;
};
